import { DEFAULT_VAT_PERCENT } from "../../../components/common/vatDefaults";

// The one VAT rate a quotation charges (2026-10-28, customer: "VAT 16% fixed to
// show there"). Every quotation/prototype line carries it whatever the product's
// own Product Master VAT says (labour etc. is 0 there, which made a mixed
// quotation print "VAT 11%"). The API forces the same rate on save
// (QuotationService.FixedVatPercent) - keep the two equal.
export const QUOTATION_VAT_PERCENT = DEFAULT_VAT_PERCENT;
